(function () {
  function getMoneyFormat() {
    var root = document.querySelector('[data-cs-accessory-recs]');
    if (root && root.getAttribute('data-money-format')) {
      return root.getAttribute('data-money-format');
    }
    if (window.theme && window.theme.moneyFormat) {
      return window.theme.moneyFormat;
    }
    return '${{amount}}';
  }

  function formatMoney(cents) {
    var format = getMoneyFormat();
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount).replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function fitAccessoryRecSelectWidth(selectEl) {
    if (!selectEl || !selectEl.options.length) return;

    var card = selectEl.closest('.cs-accessory-rec__card');
    var label = selectEl.closest('label.cs-accessory-rec__variant');
    var body = selectEl.closest('.cs-accessory-rec__body');
    if (!card || !label || !body) return;

    var isMobile = window.matchMedia('(max-width: 767px)').matches;

    if (isMobile) {
      var cardStyle = window.getComputedStyle(card);
      var padX = parseFloat(cardStyle.paddingLeft) + parseFloat(cardStyle.paddingRight);
      var gap = parseFloat(cardStyle.columnGap || cardStyle.gap) || 10;
      var media = card.querySelector('.cs-accessory-rec__media');
      var form = card.querySelector('.cs-accessory-rec__form');
      var mediaW = media ? media.getBoundingClientRect().width : 0;
      var formW = form ? form.getBoundingClientRect().width : 0;
      var maxLabelWidth = card.clientWidth - padX - mediaW - formW - gap * 2;

      if (!Number.isFinite(maxLabelWidth) || maxLabelWidth < 0) {
        maxLabelWidth = body.clientWidth;
      }

      label.style.maxWidth = Math.max(0, maxLabelWidth) + 'px';
      label.style.width = '100%';
      selectEl.style.width = '100%';
      selectEl.style.maxWidth = '100%';
      return;
    }

    label.style.maxWidth = '';
    label.style.width = '';

    var measure = document.createElement('span');
    measure.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;pointer-events:none;';
    measure.style.font = window.getComputedStyle(selectEl).font;
    document.body.appendChild(measure);

    var selectedOption = selectEl.options[selectEl.selectedIndex];
    var selectedText = selectedOption ? selectedOption.textContent.trim() : '';
    measure.textContent = selectedText;
    var textWidth = measure.offsetWidth;
    document.body.removeChild(measure);

    var labelStyle = window.getComputedStyle(label);
    var padL = parseFloat(labelStyle.paddingLeft) || 0;
    var padR = parseFloat(labelStyle.paddingRight) || 0;
    var bodyWidth = body.clientWidth;
    var minInner = 28;
    var innerWidth = Math.max(textWidth, minInner);

    if (bodyWidth > 0) {
      var maxInner = bodyWidth - padL - padR;
      if (maxInner > 0 && innerWidth > maxInner) {
        innerWidth = maxInner;
        selectEl.style.overflow = 'hidden';
        selectEl.style.textOverflow = 'ellipsis';
      } else {
        selectEl.style.overflow = '';
        selectEl.style.textOverflow = '';
      }
      label.style.maxWidth = bodyWidth + 'px';
    } else {
      selectEl.style.overflow = '';
      selectEl.style.textOverflow = '';
      label.style.maxWidth = '';
    }

    selectEl.style.width = innerWidth + 'px';
    selectEl.style.maxWidth = innerWidth + 'px';
    label.style.width = innerWidth + padL + padR + 'px';
  }

  function openAccessoryRecSelect(select) {
    if (!select) return;
    try {
      if (typeof select.showPicker === 'function') {
        select.showPicker();
        return;
      }
    } catch (err) {}
    select.focus({ preventScroll: true });
    select.click();
  }

  function initAccessoryRecVariantPickers() {
    document.querySelectorAll('.cs-accessory-rec__variant-chevron').forEach(function (chevron) {
      chevron.addEventListener('mousedown', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var label = chevron.closest('label.cs-accessory-rec__variant');
        openAccessoryRecSelect(label && label.querySelector('select'));
      });
      chevron.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    document.querySelectorAll('label.cs-accessory-rec__variant').forEach(function (label) {
      label.addEventListener('click', function (e) {
        if (e.target.tagName === 'SELECT') return;
        if (e.target.classList.contains('cs-accessory-rec__variant-chevron')) return;
        e.preventDefault();
        openAccessoryRecSelect(label.querySelector('select'));
      });
    });
  }

  function updateAccessoryRecCard(selectEl) {
    var card = selectEl.closest('.cs-accessory-rec__card');
    if (!card) return;

    var option = selectEl.options[selectEl.selectedIndex];
    var variantId = selectEl.value;
    var price = option.getAttribute('data-price');
    var compareAt = option.getAttribute('data-compare-at');
    var idInput = card.querySelector('[data-accessory-variant-id]');
    var addBtn = card.querySelector('[data-cs-accessory-add-btn]');

    if (idInput) idInput.value = variantId;

    var priceWrap = card.querySelector('[data-cs-accessory-rec-price] .cs-accessory-rec__price-line');
    if (priceWrap && price) {
      var html = '<ins><span class="cs-accessory-rec__amount">' + formatMoney(parseInt(price, 10)) + '</span></ins>';
      if (compareAt && parseInt(compareAt, 10) > parseInt(price, 10)) {
        html += '<del><span class="cs-accessory-rec__amount">' + formatMoney(parseInt(compareAt, 10)) + '</span></del>';
      }
      priceWrap.innerHTML = html;
    }

    if (addBtn) {
      if (option.disabled) {
        addBtn.setAttribute('disabled', 'disabled');
      } else {
        addBtn.removeAttribute('disabled');
      }
    }

    var imageUrl = option.getAttribute('data-image');
    var imageEl = card.querySelector('[data-cs-accessory-rec-image]');
    if (imageEl && imageUrl) {
      imageEl.src = imageUrl;
      imageEl.removeAttribute('srcset');
      var imageAlt = option.getAttribute('data-image-alt');
      if (imageAlt) {
        imageEl.alt = imageAlt;
      }
    }

    fitAccessoryRecSelectWidth(selectEl);
  }

  var ACCESSORY_REC_ADDED_MS = 2000;

  function formatCartBadgeCount(count) {
    if (count > 99) return '99+';
    return String(count);
  }

  function updateHeaderCartCount(cartData) {
    var loadCart =
      cartData && typeof cartData.item_count === 'number'
        ? Promise.resolve(cartData)
        : fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
            return response.json();
          });

    return loadCart
      .then(function (cart) {
        var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
        var display = formatCartBadgeCount(count);

        document.querySelectorAll('.header__cart__icon-wrap').forEach(function (wrap) {
          var badge = wrap.querySelector('[data-cart-count]');
          if (count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'header__cart__count';
              badge.setAttribute('data-cart-count', '');
              badge.setAttribute('aria-hidden', 'true');
              wrap.appendChild(badge);
            }
            badge.textContent = display;
          } else if (badge) {
            badge.remove();
          }
        });

        try {
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: { cart: cart, source: 'AccessoryRecommendations' },
            })
          );
        } catch (err) {}
      })
      .catch(function () {});
  }

  function getAccessoryRecAddLabelEl(addBtn) {
    return addBtn.querySelector('span') || addBtn;
  }

  function getAccessoryRecAddedLabel() {
    var root = document.querySelector('[data-cs-accessory-recs]');
    return (root && root.getAttribute('data-added-label')) || '√Added';
  }

  function restoreAccessoryRecAddEnabled(addBtn, card) {
    var selectEl = card && card.querySelector('.cs-accessory-rec__variant-select');
    var optionDisabled =
      selectEl &&
      selectEl.options[selectEl.selectedIndex] &&
      selectEl.options[selectEl.selectedIndex].disabled;
    if (!optionDisabled) {
      addBtn.removeAttribute('disabled');
    }
  }

  function showAccessoryRecAddedState(addBtn, card, onRestored) {
    var labelEl = getAccessoryRecAddLabelEl(addBtn);
    if (!addBtn.dataset.csAccessoryAddDefault) {
      addBtn.dataset.csAccessoryAddDefault = labelEl.textContent.trim();
    }

    if (addBtn._csAddedTimer) {
      clearTimeout(addBtn._csAddedTimer);
      addBtn._csAddedTimer = null;
    }

    labelEl.textContent = getAccessoryRecAddedLabel();
    addBtn.classList.add('is-added');
    addBtn.setAttribute('disabled', 'disabled');

    addBtn._csAddedTimer = window.setTimeout(function () {
      labelEl.textContent = addBtn.dataset.csAccessoryAddDefault;
      addBtn.classList.remove('is-added');
      addBtn._csAddedTimer = null;
      restoreAccessoryRecAddEnabled(addBtn, card);
      if (typeof onRestored === 'function') onRestored();
    }, ACCESSORY_REC_ADDED_MS);
  }

  function refreshCartUiAfterAdd(addBtn) {
    var minicart = document.querySelector('mini-cart');

    if (minicart && typeof minicart.open === 'function') {
      minicart.open(addBtn);
      return;
    }

    try {
      document.dispatchEvent(new CustomEvent('open-mini-cart', { detail: { opener: addBtn } }));
    } catch (err) {}
  }

  function handleAccessoryRecAddClick(e) {
    e.preventDefault();
    e.stopPropagation();

    var addBtn = e.currentTarget;
    if (addBtn.disabled) return;

    var card = addBtn.closest('.cs-accessory-rec__card');
    var idInput = card && card.querySelector('[data-accessory-variant-id]');
    var variantId = idInput && idInput.value;
    if (!variantId) return;

    addBtn.setAttribute('disabled', 'disabled');
    addBtn.classList.add('is-loading');

    var minicart = document.querySelector('mini-cart');
    var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    var addSucceeded = false;

    if (minicart && typeof minicart.getSectionsToRender === 'function') {
      var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append(
        'sections',
        minicart.getSectionsToRender().map(function (section) {
          return section.section;
        }).join(',')
      );
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(cartAddUrl, config)
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          addSucceeded = handleAddResponse(response);
        })
        .catch(handleAddError)
        .finally(function () {
          finishAddButton(addBtn, card, addSucceeded);
        });
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        addSucceeded = handleAddResponse(response);
      })
      .catch(handleAddError)
      .finally(function () {
        finishAddButton(addBtn, card, addSucceeded);
      });

    function handleAddResponse(response) {
      if (response.status) {
        window.alert(response.description || response.message || 'Could not add to cart');
        if (minicart && typeof minicart.updateSectionContents === 'function') {
          minicart.updateSectionContents();
        }
        return false;
      }

      updateHeaderCartCount();

      if (minicart && typeof minicart.renderContents === 'function' && response.sections) {
        minicart.renderContents(response);
        refreshCartUiAfterAdd(addBtn);
      } else if (minicart && typeof minicart.updateSectionContents === 'function') {
        minicart.updateSectionContents().then(function () {
          refreshCartUiAfterAdd(addBtn);
        });
      } else {
        refreshCartUiAfterAdd(addBtn);
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartItemAdd, {
          source: 'AccessoryRecommendations',
          items: [response],
        });
      }

      return true;
    }

    function handleAddError() {
      window.alert('Could not add to cart');
    }
  }

  function finishAddButton(addBtn, card, succeeded) {
    addBtn.classList.remove('is-loading');
    if (succeeded) {
      showAccessoryRecAddedState(addBtn, card);
      return;
    }
    restoreAccessoryRecAddEnabled(addBtn, card);
  }

  function syncAllAccessoryRecCards() {
    document.querySelectorAll('.cs-accessory-rec__variant-select').forEach(function (selectEl) {
      updateAccessoryRecCard(selectEl);
    });
  }

  function initAccessoryRecCarousel(root) {
    var track = root.querySelector('[data-cs-accessory-track]');
    var slides = track ? track.querySelectorAll('[data-cs-accessory-slide]') : [];
    var prevBtn = root.querySelector('[data-cs-accessory-prev]');
    var nextBtn = root.querySelector('[data-cs-accessory-next]');
    var nav = root.querySelector('[data-cs-accessory-nav]');

    if (!track || !slides.length) return;

    if (slides.length <= 1) {
      if (nav) nav.setAttribute('hidden', 'hidden');
      track.style.transform = '';
      return;
    }

    if (nav) nav.removeAttribute('hidden');

    var index = 0;

    function fitVisibleSlideSelects() {
      var slide = slides[index];
      if (!slide) return;
      slide.querySelectorAll('.cs-accessory-rec__variant-select').forEach(fitAccessoryRecSelectWidth);
    }

    function updateCarousel() {
      track.style.transform = 'translate3d(' + -index * 100 + '%, 0, 0)';
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= slides.length - 1;
      fitVisibleSlideSelects();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (index > 0) {
          index -= 1;
          updateCarousel();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (index < slides.length - 1) {
          index += 1;
          updateCarousel();
        }
      });
    }

    updateCarousel();
  }

  function initAccessoryRecommendations() {
    var root = document.querySelector('[data-cs-accessory-recs]');
    if (!root) return;

    syncAllAccessoryRecCards();

    if (root.getAttribute('data-cs-bound') === '1') return;
    root.setAttribute('data-cs-bound', '1');

    initAccessoryRecCarousel(root);

    document.querySelectorAll('.cs-accessory-rec__variant-select').forEach(function (selectEl) {
      selectEl.addEventListener('change', function () {
        updateAccessoryRecCard(selectEl);
      });
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('.cs-accessory-rec__variant-select').forEach(fitAccessoryRecSelectWidth);
    });

    document.querySelectorAll('[data-cs-accessory-add-btn]').forEach(function (btn) {
      btn.addEventListener('click', handleAccessoryRecAddClick);
    });

    initAccessoryRecVariantPickers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccessoryRecommendations);
  } else {
    initAccessoryRecommendations();
  }

  window.addEventListener('pageshow', function (e) {
    syncAllAccessoryRecCards();
    window.setTimeout(syncAllAccessoryRecCards, 0);
    if (e.persisted) {
      window.setTimeout(syncAllAccessoryRecCards, 200);
    }
  });
})();
